document.addEventListener('DOMContentLoaded', function () {
    const careerFilters = document.querySelectorAll('.careers-filters select');
    const form = document.querySelector('.careers-filters');

    if (careerFilters) {
        careerFilters.forEach(selectElement => {
            selectElement.addEventListener('change', function() {

                const url = window.location.origin + window.location.pathname;
                const formData = new FormData(form);
                const params = new URLSearchParams(formData).toString();

                form.parentElement.classList.add('careers-loading');
                document.getElementById('loading-message').textContent = 'Careers are loading';
                document.querySelector('.careers-list-loader').classList.remove('hidden');

                fetch(`${url}?${params}`, {
                    method: 'GET'
                })
                    .then(response => response.text())
                    .then(htmlText => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlText, 'text/html');

                        const msg = doc.querySelector('#search-results-message')?.innerHTML || '';
                        const results = doc.querySelector('.careers-list__sections')?.innerHTML || '';

                        const resultsContainer = document.querySelector('.careers-list__sections');
                        const messageContainer = document.querySelector('#search-results-message');

                        if (resultsContainer) resultsContainer.innerHTML = results;
                        if (messageContainer) messageContainer.innerHTML = msg;

                        document.querySelectorAll('.choices__item').forEach(item => {
                            item.removeAttribute('aria-selected');
                        });
                    })
                    .catch(error => {
                        console.error('Fetch error:', error);
                    })
                    .finally(() => {
                        form.parentElement.classList.remove('careers-loading');
                        document.querySelector('.careers-list-loader').classList.add('hidden');
                        document.getElementById('loading-message').textContent = '';
                    });
            });
        });

        // Scroll si hay filtros aplicados
        if (document.querySelector('.careers-filters.filters-applied')) {
            const parent = document.querySelector('.careers-filters').parentElement;
            if (parent) {
                // Respect prefers-reduced-motion preference
                window.scrollTo({
                    top: parent.offsetTop,
                    behavior: window.prefersReducedMotion ? 'auto' : 'smooth'
                });
            }
        }
    }
});